import { cmApi } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'

export type InvalidatePnlBody = {
  accountId: string
  comment: string
}

export type InvalidateBetsBody = {
  accountId: string
  betIds: string[]
  reason: string
}

type InvalidateApiResult = {
  value?: boolean
  success?: boolean
  message?: string
}

/** Lab-friendly copy for Result-API / transport failures. */
export function invalidateFailureMessage(raw: string | undefined): string {
  const msg = String(raw || '').trim()
  if (!msg) return 'Invalidate failed'
  // Prefer CM-mapped Lab strings; only remap raw Result reasons.
  if (msg === 'already_invalid_or_rollback') {
    return 'Settlement already invalid or rolled back'
  }
  if (msg === 'bets_already_invalid') {
    return 'Selected bet(s) are already invalid — cannot invalidate again'
  }
  if (msg === 'fetch failed' || /^internal server error$/i.test(msg)) {
    return 'Could not reach settlement service. Try again.'
  }
  return msg
}

function assertInvalidateOk(res: InvalidateApiResult): InvalidateApiResult {
  if (res.value === false || res.success === false) {
    throw new Error(invalidateFailureMessage(res.message))
  }
  return res
}

export async function postInvalidatePnl(body: InvalidatePnlBody) {
  const res = await cmApi.invalidPNL(authHeaders(), body)
  return assertInvalidateOk(res)
}

export async function postInvalidateBetsAfterResult(body: InvalidateBetsBody) {
  const res = await cmApi.invalidBetsAfterResult(authHeaders(), body)
  return assertInvalidateOk(res)
}
